import { PropsWithChildren } from 'react';
import { Typography } from '@design-system/components/typography/typography';
import SuperTooltip from '@client/new/components/SuperTooltip/SuperTooltip';
import {
  header,
  headerWrapper,
  wrapper,
  wrapperClassName,
} from './PageWrapper.css';

export const PageWrapper = (p: PropsWithChildren) => (
  <div className={wrapper}>
    <div className={headerWrapper}>
      <div className={header}>
        <Typography variant="headline" size="large" id="page-title">
          Offers
        </Typography>
        <SuperTooltip
          templateId="offers-banner"
          wrapperClassName={wrapperClassName}
          showDivider={true}
        />
      </div>
    </div>
    <div className="my-5 2xl:my-10 h-full">{p.children}</div>
  </div>
);
